import { title } from "../../../../../assets/jss/material-kit-react.jsx"

const productStyle = {
    section: {
        padding: "70px 0",
        textAlign: "center",
    },
    featuresSection: {
        textAlign: "center",
        padding: "100px 5px 80px",
        backgroundColor: "#fff",
    },
    marketingSection: {
        textAlign: "center",
        padding: "70px 30px 70px",
        backgroundColor: "#fff",
    },
    pricingSection: {
        textAlign: "center",
        padding: "100px 30px 100px",
        backgroundColor: "#fff",
    },
    title: {
        ...title,
        marginBottom: "1rem",
        marginTop: "30px",
        minHeight: "32px",
        textDecoration: "none",
    },
    marketingBoxTitle: {
        color: "#fff",
        fontWeight: "500",
        fontSize: "14px",
    },
    marketingBoxDescription: {
        color: "#fff",
        fontWeight: "400",
        padding: "1.5rem 1rem",
        fontSize: "14px",
    },
    featureBoxDescription: {
        color: "rgb(102,102,102)",
        fontWeight: "300",
        border: "1px solid #ececec",
        padding: "1.5rem 1rem",
        margin: "1rem",
        fontSize: "14px",
        borderRadius: "8px",
    },
    featureImagesDescription: {
        color: "rgb(102,102,102)",
        fontWeight: "400",
        padding: "1.5rem 1rem",
        fontSize: "14px",
    },
    productImagesDescription: {
        color: "rgb(102,102,102)",
        fontWeight: "400",
        fontSize: "14px",
        paddingTop: "0.4rem",
    },
    productImage: {
        maxWidth: "100%",
        maxHeight: "15rem",
        borderRadius: "5px",
    },
    featureBoxTitle: {
        color: "rgb(37, 37, 37)",
        fontWeight: "500",
        fontSize: "14px",
    },
    description: {
        color: "#808080",
        fontWeight: "400",
        fontSize: "1.1rem",
        lineHeight: "1.6",
        padding: "0 2rem 0 2rem",
        maxWidth: "1200px",
    },
    optimizeBoxTitle: {
        color: "rgb(37, 37, 37)",
        fontWeight: "400",
        fontSize: "2rem",
        marginTop: 0,
    },
    optimizeDescription: {
        color: "rgb(128, 128, 128)",
        fontWeight: "400",
        fontSize: "1.1rem",
        lineHeight: "1.6",
        maxWidth: "1200px",
        paddingTop: "1rem",
    },
    mobilePictureWrapper: {
        paddingRight: "4rem",
        "@media (max-width: 900px)": {
            paddingRight: 0,
            paddingTop: "2rem",
        },
    },
}

export default productStyle



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx